export default __webpack_public_path__ + "static/media/running (1).4f4b1209.png";